import { useState } from "react";
import { toast } from "sonner";
import { saveName, addTag, removeTag } from "../lib/api";

/** Encapsulates name + tag editing for a single video. */
export function useVideoEditor(video, refresh) {
  const [name, setName] = useState(video.name);
  const [savedName, setSavedName] = useState(false);
  const [tags, setTags] = useState(video.tags);
  const [busy, setBusy] = useState(false);

  const updateName = (value) => {
    setName(value);
    setSavedName(false);
  };

  const saveCurrentName = async () => {
    if (!name.trim()) return;
    setBusy(true);
    try {
      await saveName(video.ratingKey, name.trim());
      setSavedName(true);
      setTimeout(() => setSavedName(false), 3000);
      refresh();
    } catch {
      toast.error("Couldn't save the name. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const applyTag = async (tag) => {
    if (tags.includes(tag)) {
      toast("That tag is already added.");
      return;
    }
    setTags((prev) => [...prev, tag].sort());
    try {
      await addTag(video.ratingKey, tag);
      toast.success(`Added “${tag}”`);
      refresh();
    } catch {
      setTags((prev) => prev.filter((t) => t !== tag));
      toast.error("Couldn't add the tag. Please try again.");
    }
  };

  const removeCurrentTag = async (tag) => {
    setTags((prev) => prev.filter((t) => t !== tag));
    try {
      await removeTag(video.ratingKey, tag);
      toast(`Removed “${tag}”`);
      refresh();
    } catch {
      setTags((prev) => [...prev, tag].sort());
      toast.error("Couldn't remove the tag. Please try again.");
    }
  };

  return { name, updateName, savedName, tags, busy, saveCurrentName, applyTag, removeCurrentTag };
}
